import { render } from "./GameOptions.vue?vue&type=template&id=2f45aa72&scoped=true"
import script from "./GameOptions.vue?vue&type=script&lang=js"
export * from "./GameOptions.vue?vue&type=script&lang=js"

import "./GameOptions.vue?vue&type=style&index=0&id=2f45aa72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f45aa72"]])

export default __exports__